export default {
  data() {
    return {
      //
      studentType: this.$store.state.systemLevel === 'kinder' ? 1 : (this.$store.state.systemLevel === 'school' ? 2 : 0),
      studentTypeName: '',
      studentTypeName2: '',
      adminLevel: this.$store.state.adminLevel,
      gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级'],
      // API 请求需要的分页数据
      pageableDto: {
        page: 1,
        size: 10,
        sort: 'desc',
        sortProperties: []
			},
			// 街道 社区 学校 三级联动
			streetList: this.$store.state.streetList,
			villageList: []
    };
	},

  created() {
    if (this.studentType === 1) {
      this.studentTypeName = '幼儿';
      this.studentTypeName2 = '幼儿';
    } else {
      this.studentTypeName = '学生';
      this.studentTypeName2 = '随迁子女';
    }
  },

  watch: {},

  methods: {
		beforeChangeStreet(value) {
			let currentStreet = this.streetList.find(v => v.code == value);
			console.log('currentStreet', currentStreet);
			this.form.setFieldsValue({ school: undefined });

			if (currentStreet && currentStreet.children) {
				// 区分学校和社区
				// this.villageList = currentStreet.children;
				// 重置villageCode

				// if (currentStreet.children.length <= 0) {
				// 	this.$nextTick(() => {
				// 		this.getKinderSchoolData();
				// 	});
				// }
			} else {
				// this.villageList = [];
			}

			this.$nextTick(() => {
				this.getKinderSchoolData();
			});

			this.onChangeStreet(value);
		},

		onChangeStreet() {},
		onChangeVillage() {},
		onChangeSchool() {},

		// beforeChangeVillage(value) {
		// 	let currentVillage = this.villageList.find(v => v.code === value);
		// 	console.log('currentVillage', currentVillage);
    //
		// 	this.$nextTick(() => {
		// 		this.getKinderSchoolData();
		// 	});
    //
		// 	this.onChangeVillage(value);
		// },

		async getKinderSchoolData(params) {
			let { data } = await this.fetchKinderSchool(params);
			this.schoolList = data;
			this.form.setFieldsValue({ 'school': undefined });
		},
		// 获取幼儿园列表
		async fetchKinderSchool(args) {
			let params = args || this.form.getFieldsValue();
			let streetCode = params.street || params.streetCode || ''
				// villageCode = params.villageCode || '';
				// console.log('value', params)

			let signupNoticeId = this.form.getFieldsValue().signupId;
			if(!signupNoticeId) return this.$message.error('还未创建报名活动！');

			// 报名端-根据街道CODE查询学校列表 #李茹钰/2019-03-12#
			// let { data } = await this.$ajax.gateway('/bm-kids/ISchoolApi_searchSchool', {
			// 	METHOD: 'get',
			// 	signupNoticeId,
			// 	streetCode,
			// 	villageCode
			// });
			// 报名端-根据街道CODE查询幼儿园列表 #李茹钰/2020-06-02#
			let {data,error} = await this.$ajax.gateway("/bm-kids/ISchoolApi_searchSchoolByAreaCode_1", {
				"METHOD": "get",
				signupNoticeId,
				streetCode,
				// villageCode
			});

			if (data) {
				return data;
			} else {
				this.$message.error('获取学校列表失败！');
				return { data: null };
			}
		}
	}
};
